import React from 'react';
import { Link } from 'react-router-dom';

import FingLogo from '../../assets/image/logo/fing_logo.png';
/**
 * Copyright (c) Fing Ltd. All rights reserved.
 *
 * @author Tommaso Latini <tommaso@fing.com>
 */
export default class NavbarLogo extends React.Component {

    render() {

        return (
            <Link className="navbar-brand" to="/" aria-label="Fing Logo">
                <img style={{ width: 75 }} className="img-fluid" src={FingLogo} alt="Logo" />
            </Link>
        )
    }
};